<template>
  <div>
    <h3 @click="enableDebug($event)" class="display-4">Manage Employees</h3>

    <o-list-toolbar
      :filters-list="filter_list"
      :list-options="list_options"
      :new-to="{ name: 'employee.create', params: { id: 0 } }"
      :query-select-options="options"
      :schema="schema"
      :search-fields-list="search_field_list"
      :selected-filter="selected_filter"
      @filter_changed="update_filter($event)"
      @options_changed="update_table($event)"
      @reset_table="reset_table"
      new-button-text="New Employee"
    >
      <template slot="middle">
        <!-- <o-list-multi-actions
          :schema="schema"
          :selection="selected"
          @delete="doDeleteItems"
          @merge="doMergeItems"
          enable-delete
          enable-merge
        /> -->
      </template>
    </o-list-toolbar>
    <!-- @row-selected="onRowSelected"
      :selectable="selected.selectable" :key="selected.selectable" -->

    <b-table
      :fields="fields"
      :items="items"
      :sort-by="list_options.sort"
      :sort-desc="list_options.order == 'desc'"
      @sort-changed="change_sort"
      bordered
      class="o-list"
      head-variant="light"
      no-local-sorting
      striped
      thead-class="o-gradient-header"
    >
      <template v-slot:cell(_selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template slot="cell(name)" slot-scope="{ index, item }">
        <router-link :to="{ name: 'employee.edit', params: { id: item.id } }">
          <default-display :value="item.name"></default-display>
        </router-link>
      </template>
      <template slot="cell('crew_supplier')" slot-scope="{ index, item }">
        <lookup-display
          :list="optionCrewItemsById"
          :value="item.crew_supplier"
          default-value="-"
          display-field="name"
        ></lookup-display>
      </template>
      <template slot="cell(crew_leader)" slot-scope="{ index, item }">
        <boolean-display :value="item.crew_leader"></boolean-display>
      </template>
      <template slot="cell(email)" slot-scope="{ index, item }">
        <default-display :value="item.email"></default-display>
      </template>
      <template slot="cell(active_start_date)" slot-scope="{ index, item }">
        <date-display
          :value="item.active_start_date"
          format="DD/MM/YYYY hh:mm"
        ></date-display>
      </template>
      <template slot="cell(active_end_date)" slot-scope="{ index, item }">
        <date-display
          :value="item.active_end_date"
          format="DD/MM/YYYY hh:mm"
        ></date-display>
      </template>

      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{ name: 'employee.create' }"
          >create a new item</router-link
        >
      </template>
    </b-table>

    <o-list-paging
      :limit="list_options.limit"
      :offset="list_options.offset"
      :page-options="rows_per_page_items"
      :total-items="total_items"
      @change-limit="change_limit"
      @change-page="change_page"
    />
  </div>
</template>

<style></style>

<script>
import {
  CreateCodeTableFetchMixin,
  CreateGroupPermissionMixin,
  CreateListPageMixin,
  MultiActionsMixin,
} from "../../../vue-ocom/mixins";
import {
  fieldToTableColumn,
  GetSearchFields,
} from "../../../vue-ocom/schema/schema_utils";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import schema from "../../schema/index";

import OListToolbar from "../../../vue-ocom/components/list/OListToolbar";
import OListPaging from "../../../vue-ocom/components/list/OListPaging";
import DefaultDisplay from "../../../vue-ocom/components/display/DefaultDisplay";
import DateDisplay from "../../../vue-ocom/components/display/DateDisplay";
import NumberDisplay from "../../../vue-ocom/components/display/NumberDisplay";
import BooleanDisplay from "../../../vue-ocom/components/display/BooleanDisplay";
import LookupDisplay from "../../../vue-ocom/components/display/LookupDisplay";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad";
import EmailIcon from "vue-material-design-icons/Email";
import LinkIcon from "vue-material-design-icons/Link";
import CrewSupplierMixin from "@/mixins/CrewSupplierMixin";

export default {
  components: {
    EmoticonSadIcon,
    EmailIcon,
    LinkIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay,
  },
  mixins: [
    CreateListPageMixin("Employee", "employee"),
    MultiActionsMixin,
    CreateGroupPermissionMixin("Employee"),
    CreateCodeTableFetchMixin(["Supplier"]),
    CrewSupplierMixin(),
  ],
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.Employee,
        {}
      ) /*Use this.schema instead */,

      search_field_list: GetSearchFields(schema.Employee),

      filter_list: [
        { name: "Active", code: "active", options: { offset: 0, sort: "id" } },
        {
          name: "Non Active",
          code: "inactive",
          options: { offset: 0, sort: "id" },
        },
        { name: "All", code: "all", options: { offset: 0, sort: "id" } },
      ],
    };
  },
  computed: {
    options() {
      return {
        Crew: {
          options: this.optionCrewItems,
          textField: "name",
          valueField: "id",
        },
      };
    },
    fields() {
      return this.addSelectionColums(
        this.filterTableColumns(this.schema, [
          fieldToTableColumn(this.schema, "name"),
          fieldToTableColumn(this.schema, "crew"),
          fieldToTableColumn(this.schema, "crew_leader"),
          fieldToTableColumn(this.schema, "email"),
          fieldToTableColumn(this.schema, "active_start_date"),
          fieldToTableColumn(this.schema, "active_end_date"),
        ])
      );
    },
  },
};
</script>
